var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownWhiteTwo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0_6431_6980)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6431_6980",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6431_6980",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6431_6980",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADWElEQVR4nO3cO4hcZRTA8YxPoihCQBOf8UGIAZGYgEoURTEIBgtFC9EihWBhYSHYWFhYpEghRLCwCFoIFlaWgiAINlqI4ivGuISIGiVGE43Pn8VMMSwz95u5c2fOvbPnV+7unP3O999ld4dh161LKaWUUlqLetEHmBSMenuv1+vMDqOcFX2AtS4DBMsAwTJAsAwQLAMEywDBMkCwDBAsAwTLAMEyQLAMECwDBMsAwTJAsAwQLAMEywDBMkCwDBAsAwTLAMEyQLAMECwDBMsAwTJAsAwQLAMEywDBMkCwDBAsAwTLAMEyQLAMECwDBMsAwTJAsAwQLAMEywDBMkCwDBAsAwTLAMHmEgBb8BrWz2P+PGD94Mxbos8yE1yNb/W9h4samjtSQ7MvwDuDkUdxXRNzFw5X4ZtVd/Q+Lm5g9lwC4EK8u2rsCjbPOnuhcBk+H3NPH2LDjPMbD4BL8MGY0Ydw+SzzFwoHxl3SwEezRGg6ADYMzlTlQN35C4fz8FZhoc+wqeb8xgLgUnxcOOvbOL/O/DA4G68XFvsCV9SY3UgAbMQnhTO+iXOnnd0KgwgHCwsewbVTzp05gP4vCV8VzvYGzplu65ZBDy8XFl3B9VPMnCkArsHXhTO9iuX443QQ4aXCwt9h24TzagfQ/8PwaOEsryzN5Q/Di4XFv8dNE8ypFQBbcaxwhv3o9H/grYQXChfwI24uzJg6ALbpf5dV2dfsti2F5woXcQK3Vjx+qgC4Bcfz8ofg2cKF/ILbxzx24gDYiZ8Ln+v5+W7bUngK/1ZczCncM+JxEwXAHThZMf8/PLOYbVsKTxYinMZ9qx5TDIC78Fvh8p9e7LYthcfwd8VlncGDQx9fGQD34/eKef9gb8y2LYVH8VfFpf2JhwYfOzYAHsAfhct/InbblsIe/a/2qst7vOL9jyhHfDh6z1abMEKd953Bnuj9OgF3q/4BOq3T2B29V6fgTvzawOWfwr3R+3QSdqn+Pb7kJHZF79Fp2IGfalz+CdwWff6lgO3Kz+UMO47t0edeKrhR+alk+MEET2mnGpSfzz+GrdHnXGrYjMMjLn8FN0Sfb03Qf8njoaHLP6KrLyHsKv2XlHyKL3Fl9HnWpEGEjdHnSCmllFJKKaWUUuqg/wHth1vHY/4v5gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhiteTwo);
export default __webpack_public_path__ + "static/media/arrowDownWhiteTwo.d0ffc1483ea714fcf419b89203ac6048.svg";
export { ForwardRef as ReactComponent };